/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setVideoAds } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import VideoAds from 'pages/dashboard/embeds/management/ads/videoads/videoads';



/* ========== ~~~~~~~~~~ EMBED VIDEO ADs : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    videoAdsStatus: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.ads.video
});

// map actions
const mapDispatchToProps = dispatch => ({
	setVideoAds: (device, value) => dispatch(setVideoAds(device, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoAds);
